import { FRONTEND_URL } from './env'

export const DEFAULT_TITLE = 'OpenOrigin'
export const DEFAULT_DESCRIPTION = 'OpenOrigin'
export const SITE_NAME = FRONTEND_URL
export const COMPANY_NAME = 'OpenOrigin'
export const AUTHOR = 'Dev Family Team'
export const SESSION_TOKEN_KEY_NAME = 'open-origin-token'
export const PREVIEW_MODE_USER_NAME = 'jaysmith'
